import React from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import Checkbox from '@material-ui/core/Checkbox';

const DialogMap = (props) => {
  const {
    show,
    zonas,
    handleClose,
    onChangeZone,
    loading = false,
    handleDeleteZona,
  } = props;

  const icon = <CheckBoxOutlineBlankIcon fontSize='small' />;
  const checkedIcon = <CheckBoxIcon fontSize='small' />;

  return (
    <div>
      <Dialog
        open={show.show}
        fullWidth
        maxWidth='sm'
        onClose={handleClose}
        aria-labelledby='form-dialog-title'
      >
        <DialogTitle id='form-dialog-title'>
          Asigne o elimine una zona
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <Typography variant='subtitle2' gutterBottom>
              NOMBRE: {show.nombre_mpi}
              <br />
              DEPARTAMENTO: {show.departamento}
              <br />
              ZONA: {show?.zona ? show.zona : 'Sin Asignar'}
            </Typography>
          </DialogContentText>
          <Autocomplete
            id='combo-box-demo'
            options={zonas}
            freeSolo
            disableListWrap
            clearOnBlur
            loading={loading}
            handleHomeEndKeys
            value={show.zona || ''}
            getOptionLabel={option => {
              if (typeof option === 'string') {
                return option;
              }
              return option.zona;
            }}
            renderOption={(option, { selected }) => (
              <>
                <Checkbox
                  icon={icon}
                  checkedIcon={checkedIcon}
                  style={{ marginRight: 8, color: option.color }}
                  checked={selected}
                />
                {option.zona}
              </>
            )}
            onChange={(event, newValue) => onChangeZone(newValue)}
            renderInput={params => (
              <TextField
                {...params}
                label='Seleccione una Zona'
                variant='filled'
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <>
                      {loading ? (
                        <CircularProgress color='inherit' size={20} />
                      ) : null}
                      {params.InputProps.endAdornment}
                    </>
                  ),
                }}
              />
            )}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteZona} color='primary'>
            Eliminar Zona
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default DialogMap